import { ExclamationIcon } from '@heroicons/react/solid';
import { FC } from 'react';

interface IWarningProps {
  message: string;
}

export const Warning: FC<IWarningProps> = ({ message }) => {
  return (
    <div className='rounded-md bg-yellow-50 p-4 mt-5'>
      <div className='flex'>
        <div className='flex-shrink-0'>
          <ExclamationIcon
            className='h-5 w-5 text-yellow-400'
            aria-hidden='true'
          />
        </div>
        <div className='ml-3'>
          <h3 className='text-sm font-medium text-yellow-800'>
            You don't have any added content yet!
          </h3>
          <div className='mt-2 text-sm text-yellow-700'>
            <p>{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
